import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container legal-page">
      <div className="card">
        <h1>Privacy Policy</h1>
        <p>Last updated: November 19, 2025</p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Account data such as name, email, and password.</li>
          <li>Group details, invitations, and wish list items you create.</li>
          <li>Usage information (device, browser, approximate location).</li>
        </ul>

        <h2>2. How We Use Information</h2>
        <p>
          We use your information to operate the Secret Santa platform, send transactional emails, prevent abuse,
          and improve the experience.
        </p>

        <h2>3. Sharing & Third Parties</h2>
        <p>
          We share data with service providers that help us deliver emails, host the app, process payments (if any),
          or analyze usage. We do not sell personal data.
        </p>

        <h2>4. Data Retention</h2>
        <p>
          We retain account information while you maintain an account. You may request deletion by contacting
          support, and we will remove data as required by law.
        </p>

        <h2>5. Security</h2>
        <p>
          We implement reasonable safeguards, but no system is completely secure. Please keep your password safe
          and notify us of suspicious activity.
        </p>

        <h2>6. International Users</h2>
        <p>
          Data may be stored in the United States. By using the service, you consent to the transfer and processing
          of your information in the U.S.
        </p>

        <h2>7. Children</h2>
        <p>
          The service is not directed to children under 13. We delete data from children if we become aware it was
          collected without parental consent.
        </p>

        <h2>8. Updates</h2>
        <p>
          We may update this policy periodically. Continued use after changes indicates acceptance of the updated
          policy.
        </p>

        <p>
          Questions? Contact <a href="mailto:support@whoisyoursanta.com">support@whoisyoursanta.com</a>.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
